import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import * as action from "~/actions/umc/submitPayment";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

const TransferInformationMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_mobile" */ "~/components/mobile/pages/TransferInformation"
    ),
  loading: LoadableLoading
});
const TransferInformationDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/TransferInformation"
    ),
  loading: LoadableLoading
});

class DetectTransferInformation extends Component {
  componentWillUnmount() {
    this.props.cancelRedirectToPaymentSupportPage();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <TransferInformationMobile {...this.props} />
        ) : (
          <TransferInformationDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: { selectedHospital }
  } = state;
  return {
    device: type,
    data:
      selectedHospital.id === 2
        ? state.umcSubmitPayment.data
        : state.booking.submitBooking.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    cancelRedirectToPaymentSupportPage: () =>
      dispatch(action.cancelRedirectToPaymentSupportPage())
  };
};

const TransferInformationHelmet = withTitle({
  component: DetectTransferInformation,
  title: "Medpro | Hỗ trợ thanh toán"
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferInformationHelmet);
